var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit } from '@angular/core';
import { ApartmentTypesBaseComponent } from './../common-theme/index';
var HousesComponent = /** @class */ (function (_super) {
    __extends(HousesComponent, _super);
    function HousesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HousesComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setTitle('Apartamentele din oferta Romanescu Park Residence');
        this.setMetaDescription("\n      Oferta Romanescu Park Residence cuprinde o gam\u0103 variat\u0103 de apartamente, cu 2 \u0219i 3 camere.\n      Indiferent de cl\u0103direa \u00EEn care optezi s\u0103 locuie\u0219ti - Stejar, Frasin, Tei sa Ar\u021Bar - , po\u021Bi fi sigur c\u0103 vei\n      avea un c\u0103min modern, spa\u021Bios \u0219i confortabil.\n    ");
    };
    return HousesComponent;
}(ApartmentTypesBaseComponent));
export { HousesComponent };



// WEBPACK FOOTER //
// ./src/app/houses/houses.component.ts.pre-build-optimizer.js